import { actions } from '../../actions/action-list';
import initialState from "./initialState";

function Alert(state = initialState, action) {
    if (action.type === actions.SET_SELECTED_PANIC_ALERT_ROW) {
        return {
            ...state,
            selectedAlertRow: action.value
        };
    }
    return state;
}
export default Alert;
